
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/searchDetails",
      function () {
        return require("private-next-pages/searchDetails.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/searchDetails"])
      });
    }
  